import React from 'react'
import { useMobileContext } from '../../Context/ContextProvider'
import NewSiteDetail2024 from './NewSiteDetail2024'
import SiteDetailsMobile from './SiteDetailsMobile'

interface Props {
    classes: {
        cardTitleWhite: string;
        formControl: string;
        cardCategoryWhite: string;
    };
    history: {
        goBack: () => void;
    };
    location: {
        state: {
            siteId: number;
            siteName: string;
        };
        search: string;

    };
}

const SiteDetailsWrapper: React.FC<Props> = (props) => {
    const isMobile = useMobileContext()
    return isMobile ? <SiteDetailsMobile {...props} /> : <NewSiteDetail2024 {...props} />
}
export default SiteDetailsWrapper